import { z } from "zod";
import { TeamMutationIdempotencyKeySchema } from "./team-access.js";
/**
 * «Доступ → Команда» (Ден 19.10.2026: «сотрудник сразу добавляется во всю аналитику, и показывается, каких данных о нём
 * не хватает, как с сайтами»). One row per working person of the team list (/etc/hypno-team/team.json): the same
 * checks the host command `hypno-team add` prints after it did what it can by itself.
 */
export const TeamCheckKeySchema = z.enum(["amo", "telegram", "email", "consultant", "vekha_account", "deal_tasks", "arkadiy", "notify_group"]);
/** ok — есть; warn — будет само или можно лучше; missing — не хватает, нужно действие; none — не нужно этому человеку или не проверялось. */
export const TeamCheckStateSchema = z.enum(["ok", "warn", "missing", "none"]);
export const TeamCheckSchema = z.object({
    key: TeamCheckKeySchema,
    state: TeamCheckStateSchema,
    /** Short: «есть», «нет», «приглашён», «нет часов». */
    text: z.string().min(1).max(80),
    /** What to do, said as a step; null when nothing is to be done. */
    action: z.string().max(300).nullable(),
}).strict();
export const TeamRosterRoleSchema = z.enum(["sales", "lidorub", "technical"]);
export const TeamReadinessPersonSchema = z.object({
    name: z.string().min(1).max(200),
    role: TeamRosterRoleSchema,
    email: z.string().max(320).nullable(),
    telegramUsername: z.string().max(64).nullable(),
    state: z.enum(["ok", "warn", "missing"]),
    /** A sales manager with a mail and a consultant, without an account or a pending invitation. */
    canInvite: z.boolean(),
    checks: z.array(TeamCheckSchema).max(TeamCheckKeySchema.options.length),
}).strict();
export const TeamReadinessSchema = z.object({
    /** roster_unreadable: the list file is missing or broken — `problems` says why. */
    source: z.enum(["ok", "roster_unreadable"]),
    problems: z.array(z.string().max(500)).max(50),
    checkedAt: z.string().datetime({ offset: true }),
    /** The host's snapshot (Arkadiy, the notifications group): when it was taken; null — never. */
    hostCheckedAt: z.string().datetime({ offset: true }).nullable(),
    people: z.array(TeamReadinessPersonSchema).max(200),
    /** People who left (active: false), for the list's history only. */
    inactive: z.array(z.object({ name: z.string().min(1).max(200), role: TeamRosterRoleSchema }).strict()).max(200),
    canEdit: z.boolean(),
}).strict();
export const TeamRosterInviteSchema = z.object({
    name: z.string().trim().min(1).max(200),
    idempotencyKey: TeamMutationIdempotencyKeySchema,
}).strict();
//# sourceMappingURL=team-readiness.js.map